export const Errors = {
  error400: "Bad Request.",
  error401: "Authentication required.",
  error401Description:
    "The session has expired. Please log in again to continue.",
  error403: "Unauthorized.",
  error403Description: "You do not have permission to access this feature.",
  error404: "Not found.",
  error405: "Method not allowed.",
  error408: "Request timeout.",
  error409: "Conflict.",
  error410: "Gone.",
  error422: "Unprocessable content.",
  error429: "Too many requests.",
  error500: "Internal server error.",
  error501: "Not implemented.",
  error502: "Bad gateway.",
  error503: "Service unavailable.",
  error504: "Gateway timeout.",
  generic: "Oops! something has gone wrong.",
  fallbackMessage: "Please reload the page or go back.",
  // FetchError
  NotFound: "The requested resource was not found.",
  Unauthorized: "You are not authorized to perform this action.",
  Forbidden: "You do not have permission to access this resource.",
  BadRequest: "The request was invalid or cannot be served.",
  Conflict: "The request could not be completed due to a conflict.",
  WATCHLIST_IN_USE:
    "This watchlist is assigned to an event trigger and cannot be deleted.",
  InternalServerError: "An internal server error occurred.",
  ServiceUnavailable: "The service is currently unavailable.",
  TooManyRequests: "Too many requests. Please try again later.",
  UnknownError: "An unknown error occurred.",
};
